module.exports = __webpack_public_path__ + "img/snooker_bg.cf1c059a.png";